import { createSlice } from '@reduxjs/toolkit';
import { difference, union } from 'es-toolkit';

import { defaultSellerCatalogCountsSlice } from '@/redux/modules/seller/catalogCounts/sellerCatalogCounts.types';
import { fetchSellersByIds } from '@/redux/modules/seller/seller.actions';

const sellerCatalogCountsSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchSellersByIds.pending, (slice, { meta }) => {
            slice.loading = union(slice.loading, meta.arg);
        });
        builder.addCase(fetchSellersByIds.fulfilled, (slice, { payload }) => {
            if (payload.sellerCatalogCounts) {
                payload.sellerCatalogCounts.forEach((sellerCounts) => {
                    slice.byId[sellerCounts.sellerId] = {
                        ...sellerCounts,
                        upcomingCount: sellerCounts.liveCount + sellerCounts.onlineCount,
                    };
                    slice.loaded[sellerCounts.sellerId] = Date.now();
                    slice.loading = difference(slice.loading, [sellerCounts.sellerId]);
                });
            }
        });
        builder.addCase(fetchSellersByIds.rejected, (slice, { meta }) => {
            slice.loading = difference(slice.loading, meta.arg);
        });
    },
    initialState: defaultSellerCatalogCountsSlice,
    name: 'sellerCatalogCounts',
    reducers: {},
});

export const { reducer: sellerCatalogCountsReducer } = sellerCatalogCountsSlice;
